import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { VesselCrewEditPage } from './vessel-crew-edit';
import { VesselCrewEditComponentComponent } from '../vessel-crew-edit-component/vessel-crew-edit-component.component';
import { SharedModule } from '../../../shared/shared.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';
import { DailyLogPageModule } from '../../../daily-log/daily-log/daily-log.module';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    VesselCrewEditPage,
    VesselCrewEditComponentComponent,
  ],
  imports: [
    IonicPageModule.forChild(VesselCrewEditPage),
    SharedModule,
    FoundationModule,
    DailyLogPageModule,
    DirectivesModule,
  ],
})
export class VesselCrewEditModule {
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/vessel-crew/vessel-crew-edit/vessel-crew-edit.module.ts